import type { ContentTemplate } from '@/types/stylepacks.types';
import { useMemo } from 'react';
import type { GraphicItem } from '../components/video-list-graphic.types';
import { useGreenroomAudioMediaUrls } from './use-greenroom-audio-media';
import { useAppSelector } from '@/store/hooks';
import { selectStylepackAudio } from '@/store/slices/stylepacks/selectors';

const isContentTemplate = (video: ContentTemplate | GraphicItem | undefined): video is Required<ContentTemplate> => {
  return !!video && 'stylePack' in video && !!video.stylePack;
};

const isGraphicItem = (video: ContentTemplate | GraphicItem | undefined): video is Required<GraphicItem> => {
  return !!video && 'shots' in video && !!video.shots.length;
};

export const useStylepackAudio = ({ selectedVideo }: { selectedVideo: ContentTemplate | GraphicItem }) => {
  const audioUrls = useGreenroomAudioMediaUrls();
  const stylepackAudio = useAppSelector(selectStylepackAudio);
  return useMemo(() => {
    if (isGraphicItem(selectedVideo)) {
      for (const shot of selectedVideo.shots) {
        for (const feed of shot.shot_data.shotFeeds) {
          if (feed.feedType === 'audio' && feed.media) {
            return audioUrls.get(feed.media);
          }
        }
      }
    }

    if (isContentTemplate(selectedVideo)) {
      return stylepackAudio[selectedVideo.stylePack];
    }
  }, [audioUrls, selectedVideo, stylepackAudio]);
};
